<template>
  <svg viewBox="0 0 24 24" fill="none">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
    <path d="M9 3v18M15 3v18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>
